module.exports = __webpack_public_path__ + "img/polka1.51eb091c.png";